import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'
import { del, get, set } from 'idb-keyval'

const STORAGE_KEY = 'agrosdr-inbox-query-cache'

/**
 * Persists the React Query cache to IndexedDB so conversations, messages and
 * contacts already loaded remain available when the app opens offline.
 */
export const queryPersister = createAsyncStoragePersister({
  key: STORAGE_KEY,
  storage: {
    getItem: (key) => get(key),
    setItem: (key, value) => set(key, value),
    removeItem: (key) => del(key),
  },
  throttleTime: 1000,
})

export const QUERY_CACHE_MAX_AGE = 1000 * 60 * 60 * 24 * 7 // 7 days
